import { ReactNode } from "react";
import { Box, Divider, Heading, Link, Text, VStack } from "@chakra-ui/react";
import { PatientMapping } from "../../../api/ehr";
import PatientLookup from "./PatientLookup";
import { Link as RouterLink } from "react-router-dom";

type EhrBasePageProps = {
  ehrId: string;
  ehrName: string;
  cxId: string;
  setPatientMapping: (mapping: PatientMapping | undefined) => void;
  children?: ReactNode;
};

export default function EhrBasePage({
  ehrId,
  ehrName,
  cxId,
  setPatientMapping,
  children,
}: EhrBasePageProps) {
  return (
    <Box>
      <VStack p={10} align="start" spacing={8}>
        <Link as={RouterLink} to={`/ehr/${encodeURIComponent(cxId)}`} color="blue.500">
          Go to EHR List
        </Link>
        <Box>
          <Heading size="lg" mb={2}>
            {ehrName}
          </Heading>
          <Text color="gray.600">Manage {ehrName} EHR patients.</Text>
        </Box>

        <PatientLookup
          ehrId={ehrId}
          ehrName={ehrName}
          cxId={cxId}
          setPatientMapping={setPatientMapping}
        />

        {children && (
          <>
            <Divider />
            {children}
          </>
        )}
      </VStack>
    </Box>
  );
}
